export const DEFAULT_CURRENCY = "EUR";

export const COUNTRY_TO_CURRENCY = { FR: "EUR", CI: "XOF" };
